export default __webpack_public_path__ + "static/media/mag.849211a6.png";